'use strict';

var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var Marionette = require('backbone.marionette');
var Preference = require('../../models/preference').default;

export default Marionette.View.extend({
  tagName: 'li',
  className: 'preference-list-item',
  template: require('./templates/list-item.hbs'),
  events: {
    'click .clear_preference': 'onClick',
  },
  ui: {
    day: '#day',
    start_time: '#start_time',
    end_time: '#end_time',
    clear: '.clear_preference',
  },

  initialize: function (options) {
    this.model = options.model || new Preference();
    this.index = options.index;
  },

  serializeData: function () {
    var json = this.model.toJSON();
    json.days = Preference.DAYS;
    json.index = this.index;

    return json;
  },

  onRender: function() {
    var day = this.model.get('day');
    if (day) {
      this.ui.day.val(String(day));
    }

    var startTime = this.model.get('start_time');
    if (startTime) {
      this.ui.start_time.val(moment(startTime, 'HH:mm:ss').format('hh:mm A'));
    }

    var endTime = this.model.get('end_time');
    if (endTime) {
      this.ui.end_time.val(moment(endTime, 'HH:mm:ss').format('hh:mm A'));
    }
  },

  disableClearButton: function () {
    this.ui.clear.addClass('disabled');
  },

  enableClearButton: function () {
    this.ui.clear.removeClass('disabled');
  },

  onClick: function (evt) {
    evt.preventDefault();
    if (!this.ui.clear.hasClass('disabled')) {
      Radio.channel('list').trigger('removePreference', this);
    }
  },

  getModel: function () {
    return new Preference({
      type: Preference.TYPES.CERTAIN_DAYS,
      day: this.ui.day.val(),
      start_time: this.ui.start_time.val(),
      end_time: this.ui.end_time.val(),
    });
  },
});
